import React, { Component } from 'react';
import FetchCall, { partnerApi, emailExist_check } from  './../../../../API/FetchCall';

import SimpleReactValidator from 'simple-react-validator';
import { MOBILE_REGEX, URL_REGEX } from '../../../../constant.js';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';


class Contact extends Component {
  constructor(props) {
    super(props);
    let qrystr = window.location.search;
    const urlParams = new URLSearchParams(qrystr);
    let sid = urlParams.get('sid');
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      user_type: 0,
      sid: sid != null ? sid : -1,
      main_id: 0,
      first_name: '',
      last_name: '',
      designation: '',
      email: '',
      contact_number: '',
      landline: '',
      owner_type: '',
      uids: []
    }
    this.validator = new SimpleReactValidator({
      validators: {
        emailExist_check: {  // name the rule
          message: 'The :attribute Already Exist.',
          rule: (val, params, validator) => {
            return this.state.isEmailValid;
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        checkMobile: MOBILE_REGEX,
        checkUrl: URL_REGEX
      }
    });
  }
  componentDidMount() {
    if (this.state.authentication == true) {
      this.setState({
        user_type: this.state.user_data.user_type
      });
    }
    this.getContacteData();
  }
  getContacteData = () => {
    const { user_type, login_id, set_id } = this.state.user_data;

    let req = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: this.state.sid != -1 ? this.state.sid : set_id,
      url: 'getContactDetails'
    });
    partnerApi(req).then(res => {
      if (res.status === 1) {
        const data = res.result;
        this.setState({
          first_name: data.first_name,
          last_name: data.last_name,
          designation: data.designation,
          email: data.email_id,
          uids: data.uids,
          contact_number: data.phone_number,
          landline: data.landline_number,
          owner_type: data.owner_type ? data.owner_type : '',
        });
      }
    });
  };
  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
    if (propName == 'owner_type' && e.target.value == 1) {
      this.setState({
        designation: ''
      });
    }
    if (propName == 'email') {
      this.validateMail(e.target.value);
    }
  };
  validateMail = (value) => {
    const { partner_id, login_id, set_id } = this.state.user_data;
    let tid = (partner_id == login_id) ? '' : partner_id;
    let name = 'email_id';
    let type_name = 'isEmailValid';
    let req = JSON.stringify({
      [name]: value,
      sid: this.state.sid != -1 ? this.state.sid : set_id,
      vendor_id: tid,
      url: 'isemailExist_check'
    });
    let res = partnerApi(req).then(res => {
      console.log('valuee', res);
      if (res.status === 1) {
        this.setState({
          [type_name]: false
        });
      } else {
        // return res.status;
        this.setState({
          [type_name]: true
        });
      }
    });
  }


  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh')
  }
  
  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  };
  render() {
    this.validator.purgeFields();
    const { user_type } = this.state;
    return (
      <React.Fragment>

      <div class="category_block">

      <div class="titleline">
        <h4>Contact Info</h4>
      </div>

      <form onSubmit={this.submitForm}>
        <div class="box-shadow-custom">
          <div className='row'>
            <div class="form-group col-md-4">
              <label> Email Address (User name) <span class="astrick">*</span></label>
              <input type="text"
                class="form-control" name="email"
                value={this.state.email}
                onChange={this.handleChange} />
              {this.validator.message('Email Address', this.state.email, 'required|email|emailExist_check', { className: 'text-danger' })}
            </div>
            <div class="form-group col-md-4">
              <label>Name <span class="astrick">*</span></label>
              <input type="text"
                class="form-control" name="first_name"
                value={this.state.first_name}
                onChange={this.handleChange} />
              {this.validator.message('Name', this.state.first_name, 'required|alpha_space', { className: 'text-danger' })}
            </div>
          </div>
          <div className='row'>
            {/* <div class="form-group col-md-4">
              <label>Last Name <span class="astrick">*</span></label>
              <input type="text"
                class="form-control" name="last_name"
                value={this.state.last_name}
                onChange={this.handleChange} />
              {this.validator.message('Last Name', this.state.last_name, 'required|alpha_space', { className: 'text-danger' })}
            </div> */}
          </div>
          {user_type == 1 && (
            <div className='row'>

              <div class="form-group col-md-4">
                <label>Are you the owner?<span class="astrick">*</span></label><br />
                <input
                  type="radio"
                  name="owner_type"
                  checked={this.state.owner_type === '1'}
                  value='1'
                  onChange={this.handleChange}
                /> Yes&nbsp;&nbsp;
                <input
                  type="radio"
                  name="owner_type"
                  checked={this.state.owner_type === '2'}
                  value='2'
                  onChange={this.handleChange}
                /> No &nbsp;&nbsp;&nbsp;
                {this.validator.message('Owner type', this.state.owner_type, 'required', { className: 'text-danger' })}
              </div>
              {this.state.owner_type == 2 && (
                <div class="form-group col-md-4">
                  <label> Designation <span class="astrick">*</span></label>
                  <input type="text"
                    class="form-control" name="designation"
                    value={this.state.designation}
                    onChange={this.handleChange} />
                  {this.validator.message('Designation', this.state.designation, 'required|alpha_space', { className: 'text-danger' })}
                </div>
              )}

            </div>
          )}


          <div className='row'>
            <div class="form-group col-md-4">
              <label>Contact Number <span class="astrick">*</span></label>
              <div className="phone-wrapper">
                <div className="custom-select-drop dropdown">
                  <select className="form-control selectpicker">
                    <option>+91</option>
                  </select>
                </div>
                <input type="text" name="contact_number"
                  placeholder="Mobile Number"
                  value={this.state.contact_number}
                  onChange={this.handleChange} className="form-control" />
                {this.validator.message('Mobile Number', this.state.contact_number, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })}
              </div>
            </div>
            <div class="form-group col-md-4">
              <label> Landline</label>
              <input type="text"
                class="form-control" name="landline"
                value={this.state.landline}
                onChange={this.handleChange} />
              {this.validator.message('Landline', this.state.landline, 'numeric', { className: 'text-danger' })}
            </div>
          </div>
        </div>
        <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
          <button type='submit' id="btnSubmit"
            className="btn btn-primary btn-sm">
            Save
          </button>
        </div>
      </form>

      </div>
      <NotificationContainer/> 
      </React.Fragment >

    );
  }

  submitForm = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      const { user_type, login_id, partner_id, set_id } = this.state.user_data;
      let request = JSON.stringify({
        user_type: user_type,
        login_id: login_id,
        partner_id: partner_id,
        sid: this.state.sid != -1 ? this.state.sid : set_id,
        uids: this.state.uids,
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        designation: this.state.designation,
        email: this.state.email,
        contact_number: this.state.contact_number,
        landline: this.state.landline,
        owner_type: this.state.owner_type ? this.state.owner_type : '0',
        url: 'updateContact'
      });
      partnerApi(request).then(res => {
        //let toastr = '';
        if (res.status === 1) {
          NotificationManager.success(res.message);
          //toastr = window.toastr.success;
        } else {
          NotificationManager.error(res.message);
          //toastr = window.toastr.error;
        }
        /*
        toastr(res.message, {
          positionClass: "toast-bottom-right",
          containerId: "toast-bottom-right"
        });
        */

      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/update_profile/contact_profile.jsx